<template>
  <kye-dialog :visible="visible"
              v-bind="$attrs"
              v-on="$listeners"
              :title="$attrs.title || '数据导出'"
              :width="$attrs.width || '400px'"
              :showClose="false"
              :showFullScreenButton="false"
              @open="open"
              class="kye-data-export"
              :before-close="close">
    <div class="kye-data-export-content" v-loading="loading">
      <kye-form label-position="top"
          v-if="!templateOptions.show && !isTipsComp && !isFormComp">
        <kye-row>
          <kye-col :span="24">
            <kye-form-item label="导出进度">
              <el-progress :text-inside="true"
                          :stroke-width="18"
                          :percentage="progress"
                          color="rgba(142, 113, 199, 0.7)"></el-progress>
            </kye-form-item>
          </kye-col>
        </kye-row>
      </kye-form>

      <div class="template-wrap"
          v-if="isTemplateComp">
        <div class="template-wrap-tip">
          <div class="el-icon-warning"></div>
          <div class="template-wrap-tip__msg">
            <p>{{ exportTips }}</p>
          </div>
        </div>
        <div class="template-wrap-list">
          <kye-form label-width="80px">
            <kye-row>
              <kye-col :span="24">
                <kye-form-item label="选择导出字段">
                  <kye-radio-group v-model="templateOptions.type">
                    <el-radio label="10">当前页面字段</el-radio>
                    <el-radio label="20">个性设置模板</el-radio>
                  </kye-radio-group>
                </kye-form-item>
              </kye-col>
              <kye-col :span="24"
                      v-show="templateOptions.type === '20'">
                <kye-form-item label="">
                  <kye-select placeholder="请选择模板"
                              default-first-option
                              v-model="templateOptions.val">
                    <kye-option v-for="opt in templateOptions.list"
                                :key="opt.id"
                                :label="opt.templateName"
                                :value="opt.id">
                    </kye-option>
                  </kye-select>
                </kye-form-item>
              </kye-col>
            </kye-row>
          </kye-form>
        </div>
      </div>

      <Tips v-if="isTipsComp" :type="preType"></Tips>

      <Form v-if="isFormComp" ref="form" :data="preExportData.encryptFieldList"></Form>
    </div>

    <template slot="footer" v-if="isFooter">
      <template v-if="isTemplateComp && !showComp">
        <kye-button
          type="primary"
          hotkey="ctrl+s"
          @click="templateSave"
          :disabled="templateOptions.type === '20' && !templateOptions.val">确定(S)</kye-button>
        <kye-button @click="close">取消</kye-button>
      </template>

      <Footer
        v-if="!isTemplateComp && showComp"
        :isOa="isOa"
        :showFormBtn="isFormComp"
        :showMsgBtn="isMsgComp"
        @export="handleExport"
        @close="close">
      </Footer>
    </template>
  </kye-dialog>
</template>

<script>
  import Tips from './components/tips'
  import Form from './components/form'
  import Footer from './components/footer'
  export default {
    name: 'KyeDataExport',
    components: { Tips, Form, Footer },
    props: {
      visible: { // 是否显示弹窗
        type: Boolean
      },
      code: { // searchCode
        type: String
      },
      url: { // 请求api code
        type: String
      },
      menuId: { // 菜单id
        type: String
      },
      params: { // this.$refs.queryTable.getParams()
        type: [Object, Function],
        default: () => ({})
      },
      time: { // 定时请求间隔时间
        type: Number,
        default: 500
      },
      finish: { // 如果传入，则不执行默认下载操作
        type: [Function, Boolean]
      },
      axios: { // 请求修改axios
        type: Object,
        default: () => {
          return {}
        }
      },
      useTemplateExport: { // 如果true，则可以选择个性设置模板导出
        type: Boolean,
        default: false
      },
      preUrl: String // 数据预处理识别url
    },
    data () {
      return {
        loading: false,
        progress: 0,
        uuid: '',
        list: [],
        disabled: true,
        errorFile: '',
        showComp: '', // 显示组件
        isOa: false, // 是否发起oa流程
        moudleTag: this.$route.meta.tag,
        preExportData: {}, // 预导出数据
        templateOptions: {
          val: '',
          type: '10',
          show: false,
          list: []
        }
      }
    },
    computed: {
      isNew () {
        return !!this.preUrl
      },
      isTemplateComp () {
        return this.templateOptions.show && this.useTemplateExport
      },
      isFormComp () {
        return this.showComp === 'form'
      },
      isMsgComp () {
        return this.showComp === 'msg'
      },
      isTipsComp () {
        return ['tips', 'msg'].includes(this.showComp) && !!this.preType && !this.isTemplateComp
      },
      isFooter () {
        return (this.isTemplateComp || this.showComp) && !this.loading
      },
      // 1 大数据且未加密   2 非大数据且加密  3 大数据且加密  4 vip用户
      preType () {
        const { bigDataExport, fieldEncrypt, isVipUser } = this.preExportData
        let type = '-1'
        if (bigDataExport && !fieldEncrypt) {
          type = '1'
        }
        // 有加密字段，且少于6万
        if (!bigDataExport && fieldEncrypt) {
          type = '2'
        }

        // 有加密字段，且大于6万
        if (bigDataExport && fieldEncrypt) {
          type = '3'
        }

        if (isVipUser) {
          type = '4'
        }
        return type
      }
    },
    methods: {
      async open () {
        // 大数据+解密
        // bigDataExport 判断是否是大数据，以6w为分界线
        // fieldEncrypt 是否有加密字段
        // isVipUser vip用户
        if (this.isNew) {
          try {
            this.showComp = 'msg'
            this.loading = true
            const res = await this.$http(this.preUrl, this.getParams())
            this.loading = false
            this.preExportData = res
            const { bigDataExport, fieldEncrypt, isVipUser } = res
            if (bigDataExport || fieldEncrypt || isVipUser) {
              this.showComp = !fieldEncrypt ? 'msg' : 'tips'
              this.isOa = bigDataExport
              return
            }
          } catch (e) {
            this.showComp = ''
            this.loading = false
            console.error(e)
          }
        }

        // 2022-09-05 是否使用模板导出
        if (this.useTemplateExport) {
          this.showComp = ''
          this.exportTips = window.__ERPGLOABLECONFIG__.exportTips || '是否要导出当前页数据？(数据导出将被后台监控)'
          this.templateOptions.show = true
          this.templateOptions.val = ''
          this.templateOptions.type = '10'
          this.getTemplateList()
          return
        }

        if (this.isNew) {
          return
        }

        this.export()
      },
      async handleExport (type) {
        switch (+type) {
          case 1:
            this.showComp = 'form'
            break
          case 2:
            try {
              await this.$refs.form.validate()
              const data = this.$refs.form.getFormData()
              this.startExportOa({
                applyRemark: data.applyRemark,
                deCryptFieldList: data.decryptList.map(item => ({ field: item.field, fieldName: item.fieldName, apiCode: item.apiCode }))
              })
            } catch (e) {
              console.error(e)
            }
            break
          case 3:
            this.showComp = ''
            this.export()
            break
          default:
            // 无需解密
            this.startExportOa({
              applyRemark: '导出数据量较大，需负责人进行审核。'
            })
            break
        }
      },
      async startExportOa (params) {
        try {
          const menus = this.$store.getters.menus
          const menu = menus[this.moudleTag]
          await this.$http('file.export.fileApplyInfo.startExportOa', {
            menuTitle: menu.$title,
            menuPath: menu.title,
            taskId: this.preExportData.taskId,
            ...params
          }, { appkey: 55844 })
          this.close()
          this.$message.success('系统将自动为您发起OA审批,请后续在OA申请中获取数据文件')
        } catch (e) {
          console.error(e)
        }
      },
      close () {
        clearInterval(this.timer)
        this.$emit('update:visible', false)
        this.isOa = false
        this.progress = 0
        this.templateOptions.show = false
      },
      templateSave () {
        const id = this.templateOptions.val
        this.templateOptions.show = false
        this.export(id)
      },
      async getTemplateList () {
        const res = await this.$http('system.defineSearchFieldTemplate.listTemplateInfo', { searchCode: this.code })
        this.templateOptions.list = res || []
      },
      getParams () {
        let tableModel = this.params
        if (typeof tableModel === 'function') tableModel = tableModel()
        const obj = {
          ...tableModel,
          menuId: this.menuId || this.$store.state.menus[this.$route.meta.tag].id,
          searchCode: this.code
        }
        return obj
      },
      async export (id = '') {
        try {
          let tableModel = this.params
          if (typeof tableModel === 'function') tableModel = tableModel()
          const obj = {
            ...tableModel,
            menuId: this.menuId || this.$store.state.menus[this.$route.meta.tag].id,
            searchCode: this.code
          }
          if (this.useTemplateExport && id && this.templateOptions.type === '20') {
            obj.defineTemplateId = id
          }
          const res = await this.$http(this.url, obj, this.axios)
          if (res.taskId && res.taskId !== '') {
            this.timer = setInterval(() => {
              this.$http('file.file.result', {
                taskId: res.taskId
              }, { log: false }).then(exportRes => {
                if (exportRes.status === 'finish') {
                  this.$emit('success', exportRes)
                  const isUrl = exportRes.url && exportRes.url.includes('http')
                  this.progress = 100
                  this.close()
                  if (this.finish) {
                    return typeof this.finish === 'function' && this.finish(exportRes)
                  }
                  if (isUrl) {
                    // let link = document.createElement('a')
                    // link.style.display = 'none'
                    // link.target = '_blank'
                    // link.href = exportRes.url
                    // document.body.appendChild(link)
                    // link.click()
                    const urls = exportRes.urls
                    if (urls && Array.isArray(urls) && urls.length >= 2) {
                      for (let i = 0, len = urls.length; i <= len - 1; i++) {
                        const url = urls[i]
                        if (url && url.includes('http')) {
                          setTimeout(() => window.erpOpen(url, '_blank'), i * 300)
                        }
                      }
                    } else {
                      window.erpOpen(exportRes.url)
                    }
                  } else {
                    this.$message('文件错误无法下载')
                  }
                } else if (exportRes.status === 'process') {
                  if (exportRes.page / exportRes.pageTotal) {
                    let progress = parseInt((exportRes.page / exportRes.pageTotal) * 100)
                    this.progress = progress
                  } else {
                    this.progress = 0
                  }
                  if (this.progress > 100) this.progress = 100
                } else if (exportRes.status === 'exception') {
                  this.$message(exportRes.msg || '文件错误无法下载')
                  this.close()
                }
              })
            }, this.time)
          } else {
            this.$message('文件错误无法下载')
            this.close()
          }
        } catch (err) {
          this.close()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .kye-data-export {
    .template-wrap {
      display: flex;
      flex-direction: column;
      padding-top: 8px;
      &-tip {
        position: relative;
        margin-bottom: 16px;
        line-height: 20px;
        height: 20px;
        .el-icon-warning {
          position: absolute;
          color: #ffc300;
          font-size: 20px;
        }
        &__msg {
          padding-left: 28px;
        }
      }
      &-list {
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-data-export/index.vue